import React from 'react';
import CommonHeader from './CommonHeader';
import CommonFooter from './CommonFooter';
import './LegalPages.css';
import config from '../config';

const TermsOfService = ({ onNavigate, onLogin, onSignup }) => {
  const costPerPdf = parseFloat(config.COST_PER_PDF)
  const currentYear = new Date().getFullYear();

  return (
    <div className="legal-page">
      <CommonHeader
        activePage="terms"
        onNavigate={onNavigate}
        onLogin={onLogin}
        onSignup={onSignup}
      />

      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1>Terms of Service</h1>
            <p className="last-updated">Effective Date: January 1, {currentYear}</p>
          </div>

          <div className="legal-body">
            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing or using {config.APP_NAME} ("the Service"), you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.</p>
            </section>

            <section>
              <h2>2. Description of Service</h2>
              <p>{config.APP_NAME} provides a platform for creating digital forms, collecting responses, and generating PDF documents. Users can create custom forms, share them with others, and download completed forms as PDFs for printing and record-keeping.</p>
              <p><strong>Important:</strong> We do not store your form responses permanently. You are responsible for downloading and saving your generated PDFs.</p>
            </section>

            <section>
              <h2>3. User Accounts</h2>
              <p>To use certain features of the Service, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
              <ul>
                <li>You must provide accurate and complete registration information</li>
                <li>You must notify us immediately of any unauthorized use of your account</li>
                <li>You are responsible for all activities that occur under your account</li>
                <li>We reserve the right to suspend or terminate accounts that violate these terms</li>
              </ul>
            </section>

            <section>
              <h2>4. Free vs Usage Plan</h2>
              <h3>4.1 Free Plan</h3>
              <ul>
                <li>Maximum 2 templates</li>
                <li>Maximum 5 PDF generations (lifetime)</li>
                <li>Basic form fields</li>
                <li>Email support</li>
              </ul>
              
              <h3>4.2 Usage Plan</h3>
              <ul>
                <li>Unlimited templates</li>
                <li>${costPerPdf} per PDF generation</li>
                <li>All form fields including image upload</li>
                <li>Priority email support</li>
                <li>API access</li>
              </ul>
            </section>

            <section>
              <h2>5. Payments and Billing</h2>
              <p>Usage plan users pay ${costPerPdf} per PDF generation. You must maintain a positive balance to generate PDFs. Payments are processed through our secure payment processors. All charges are non-refundable except as required by law.</p>
            </section>

            <section>
              <h2>6. User Responsibilities</h2>
              <p>You agree not to use the Service to:</p>
              <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the intellectual property rights of others</li>
                <li>Upload or transmit malicious code or viruses</li>
                <li>Collect personal information from minors without proper consent</li>
                <li>Send spam or unsolicited messages</li>
                <li>Attempt to gain unauthorized access to the Service</li>
              </ul>
            </section>

            <section>
              <h2>7. Intellectual Property</h2>
              <p>You retain ownership of the forms you create and the data you collect. We claim no ownership over your content. However, by using our templates, you grant us permission to use anonymized usage data to improve our service.</p>
            </section>

            <section>
              <h2>8. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, {config.APP_NAME} shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service.</p>
            </section>

            <section>
              <h2>9. Termination</h2>
              <p>We may terminate or suspend your account immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users of the Service.</p>
            </section>

            <section>
              <h2>10. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. We will notify users of material changes via email or through the Service. Your continued use of the Service after changes become effective constitutes your acceptance of the new terms.</p>
            </section>

            <section>
              <h2>11. Contact Information</h2>
              <p>For questions about these Terms of Service, please contact us at <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a>.</p>
            </section>
          </div>
        </div>
      </div>

      <CommonFooter onNavigate={onNavigate} activePage="terms" />
    </div>
  );
};

export default TermsOfService;